import { SET_FILE_TEXT } from '../actionConstants';

export const setFileTextAction = (payload) => {
  return {
    type: SET_FILE_TEXT,
    payload,
  };
};
